module.exports = __webpack_public_path__ + "img/file-type-music.2bea298b.svg";